import { useState, useEffect, useRef } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import $, { data } from "jquery";
import DataTable from "datatables.net";
import { MainArea, MainAreaHeader, MainAreaBody } from "../../layout/MainArea";
import { getDataTableDom, requestToServer } from "../../utils/appUtils";
import TableDT from "../../UI/TableDT";
import { MapContainer, Marker, Popup, TileLayer, useMapEvents } from "react-leaflet";
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import {  useMap } from 'react-leaflet'
import "./KNAP/Knap.css"
import icon from "../../../images/car-marker.png";
import CardHeaderDashboard from "../../home/cardHeaderDashboard";
// import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import { Button } from 'primereact/button';
import { GetConnKONSUL } from "../../../api";



const ROUTE_URL = "/get_conn_knap_last";

function KonsulState(props) {
    // clearInterval(window.timer)
    const token = localStorage.getItem('token')
    const [serverData, setServerData] = useState(true);
    const [loading, setLoading] = useState(false);
    const [date, setDate] = useState();

    const { showErrorPage, messageBox } = useOutletContext();
    const { showErrorPageMap, messageBoxMap } = useOutletContext();

    const navigate = useNavigate();
    // const position = [ 55.751244, 37.618423]
    const [position, setPosition] = useState(null)

    let DefaultIcon = L.icon({
        iconUrl: icon,
        iconSize: [32], iconAnchor: [16, 16],
                // shadowUrl: iconShadow
    });
    L.Marker.prototype.options.icon = DefaultIcon;
    L.Marker.prototype.options.keyboard = false;

const refMap = useRef()



let servicesPrev = [
    { id: 1, name: "Готовность ПУ-ЛСН", status: "normal"},
    { id: 2, name: "Доступность КОНСУЛ", status: "normal"},
    { id: 3, name: "Активность соединения", status: "normal"},
    { id: 4, name: "Корректность данных", status: "normal"},
];
const [services, setServices] = useState(servicesPrev)

useEffect(() => {
            window.timer = setInterval(async () => {
                setLoading(true);

               await GetConnKONSUL(token).then( (e) => {
                    let arr = [
                        { id: 1, name: "Готовность ПУ-ЛСН", status: "normal"},
                        { id: 2, name: "Доступность КОНСУЛ", status: e.data.service_available ? "normal" : "failed"},
                        { id: 3, name: "Активность соединения", status: e.data.is_connected ? "normal" : "failed"},
                        { id: 4, name: "Корректность данных", status: e.data.is_correct ? "normal" : "failed"}
                    ];
                    setServices(arr)
                    setLoading(false);
                })
                setLoading(false);

                  }, 30000);
                }, [])

const handleClick = async (event) => {
    if (loading) return;
   event && event.preventDefault();
   event && event.target.blur();
    //    refreshData();
    setLoading(true);
    await GetConnKONSUL(token).then( (e) => {
        let arr = [
            { id: 1, name: "Готовность ПУ-ЛСН", status: "normal"},
            { id: 2, name: "Доступность КОНСУЛ", status: e.data.service_available ? "normal" : "failed"},
            { id: 3, name: "Активность соединения", status: e.data.is_connected ? "normal" : "failed"},
            { id: 4, name: "Корректность данных", status: e.data.is_correct ? "normal" : "failed"}
        ];
        setServices(arr)
        setLoading(false);
    })
    setDate(Date.now())
    setTimeout(() => {
      setLoading(false);
    }, 650);
}

  useEffect(() => {
    handleClick()
  }, [])
  useEffect(() => {
    window.timer = setInterval(async () => {
        // handleClick()
    }, 30000);
        }, [])



    // useEffect(() => {
    //     requestToServer(ROUTE_URL + "?crud", { method: 'GET' }, setServerData, showErrorPage, true);
    //     requestToServer(ROUTE_URL + "?track", { method: 'GET' }, setPosition, showErrorPageMap, true);
    // }, []);

    // useEffect(() => {        
    //     if (position?.data[0]?.latitude && position?.data[0]?.longitude ) {
    //         refMap.current.panTo([position.data[0].latitude, position.data[0].longitude])
    //     }
    // }, [position])

    if (serverData === null)
        return <MainArea loading />;

    return (
        <MainArea>
            <MainAreaHeader caption="Связь с КОНСУЛ" />
            <div className="card-body" style={{ fontSize: "0.85rem" }}>
                {(
                    services.map((item, index, array) => {
                        return (
                            <div key={item.id} className={`gap-2 col-12 d-flex align-items-center  ${index == 0 ? "" : "mt-1"}`}>
                                {loading ? (
                                        <div style={{ width: "1.25em", height: "1.25em", margin: `6.5px 0px` }} className=" spinner-border spinner-border-sm text-primary"></div>
                                    ) : (
                                        <i className={`fs-5 ${item.status == "normal" ? "bi-check-circle-fill text_green" : item.status == "failed" ||  item.status == "missing" ? "bi-x-circle-fill text-danger" : "bi-check-circle-fill text_yellow"}`}></i>
                                    )}
                                <div>
                                    <span className="link-info">
                                        {item.href ? <a className="link-info" href={`${item.href}`}>{item.name}</a> : item.name} 
                                        {/* - <small>{moment(item.date).isValid() ? moment.utc(item.date).local().format("DD.MM.YYYY HH:mm:ss") : item.date}</small> */}
                                    </span>
                                </div>
                            </div>
                        );
                    })
                )}
            </div>
            <div className="card-body">
                <div className="lower-line">
                    <div className="text-cont">
                        <div className="text">Состояние актуально на:</div>
                        <div className="text">{date ? new Date(date).toLocaleString() : ""}</div>
                    </div>
                    <Button className="btn-reload" loading={loading} label="Обновить сейчас" rounded onClick={handleClick}/>
                </div>
            
            </div>        
            
    </MainArea>
    );
}


export default KonsulState;
